import { IStyleableComponentProps } from "components/shared-ui/common/component-props";
import React, { useState, useRef, useEffect } from "react";
import {
  ClusterDeploymentStatus,
  isDeploymentCompletedStatus,
  isDeploymentPendingStatus,
} from "api/entities/buildable";
import { useApi } from "utils/hooks/use-api";
import { DotIcon, DotIconColor } from "components/shared-ui/icons/dot-icon";
import { clusterService } from "api/services/cluster";

export interface IStatusPollerProps extends IStyleableComponentProps {
  poolId: string;
}

export function StatusPoller({ poolId, className }: IStatusPollerProps) {
  const [status, setStatus] = useState<ClusterDeploymentStatus>();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  const [clusterApi] = useApi();

  const fetchStatus = async () => {
    clusterApi(clusterService.getByStoragePoolId(poolId)).then((cluster) => {
      setStatus(cluster.status);
      if (isDeploymentCompletedStatus(cluster.status)) {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      }
    });
  };

  const getColor = (status: ClusterDeploymentStatus): DotIconColor => {
    if (isDeploymentPendingStatus(status)) {
      return DotIconColor.Yellow;
    } else if (isDeploymentCompletedStatus(status)) {
      return status === ClusterDeploymentStatus.CERT_READY
        ? DotIconColor.Green
        : DotIconColor.Red;
    } else {
      return DotIconColor.Gray;
    }
  };
  const getTooltip = (status: ClusterDeploymentStatus): string => {
    if (isDeploymentPendingStatus(status)) {
      return "Provisioning";
    } else if (isDeploymentCompletedStatus(status)) {
      return status === ClusterDeploymentStatus.CERT_READY
        ? "Deployed"
        : "Failed";
    } else {
      return "Status Unknown";
    }
  };
  useEffect(() => {
    if (!poolId) return;
    
    fetchStatus(); // Initial call
    
    intervalRef.current = setInterval(() => {
      fetchStatus();
    }, 10000); // Every 10 seconds
    
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
    // eslint-disable-next-line
  }, [poolId]);

  return (
    <DotIcon color={getColor(status)} tooltip={getTooltip(status)} blink />
  );
}
